import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Typography } from 'antd';
import { BenefitItems } from 'all-in-one-shared-api';
import ProportionBar from './ProportionBar';
import { USAGE_LABEL_COLORS } from '../constants/UsageLabelColor';

const { Text } = Typography;

const UsageOverallItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 16px 24px 16px;
`;

const Title = styled(Text)`
  margin-bottom: 12px;
  color: var(--benefit-usage-title-overall-color);
`;

export interface UsageOverallItemProp {
  shouldShowVisitLimit: boolean;
  benefitItemDetails: BenefitItems[];
  maximumValue: number;
}

function UsageOverallItem({ shouldShowVisitLimit, benefitItemDetails, maximumValue }: UsageOverallItemProp) {
  const { t } = useTranslation();

  const items = benefitItemDetails.map((detail, index) => {
    return {
      id: detail.benefitCode ?? index.toString(),
      value: shouldShowVisitLimit ? parseInt(detail.limitUsed ?? '') : parseFloat(detail.paidAmount ?? ''),
      color: USAGE_LABEL_COLORS[index],
    };
  });

  return (
    <UsageOverallItemContainer>
      <Title>{shouldShowVisitLimit ? t('benefits.overallGroupLimit') : t('benefits.overallGroupAmount')}</Title>
      <ProportionBar items={items} hideValues={true} maximumValue={maximumValue} />
    </UsageOverallItemContainer>
  );
}

export default UsageOverallItem;
